<template>
  <d-select
    :items="subsForSelect"
    :itemsSelected="[]"
    :multiple="false"
    :showSelectedUsers="false"
    :placeholder="placeholder"
    :addClass="addClass"
    :isLoading="isLoading"
    @add="onAdd">
    <template v-slot:occupied-item="{ item }">
      <img v-if="item.default_thumb_url" :src="item.default_thumb_url" alt="">
      <div class="active-events-sub__meta">
        <div>{{ item.name }}</div>
        <div class="active-events-sub__busy" :title="item.occupiedTitles">
          <span class="icon-warning"></span>
          {{ item.occupiedLabel }}
        </div>
      </div>
    </template>
  </d-select>
</template>

<script>
import dSelect from './DSelect'
import Moment from 'moment'
import {extendMoment} from 'moment-range'

const moment = extendMoment(Moment)

const NON_OCCUPYING_TYPES = {
  presence: true,
  available: true
}

export default {
  components: {dSelect},
  props: {
    possibleSubs: {
      type: Array,
      default: () => []
    },
    activeEvents: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    addClass: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    allEventsInAHash () {
      return this.$store.state.subs.allEventsInAHash
    },
    selectedLessonRanges () {
      const selectedEventIds = {}
      const ranges = []
      this.activeEvents.forEach((activeEvent, idx) => {
        if (!activeEvent.lesson || !activeEvent.lesson.start || !activeEvent.lesson.end) {
          return
        }
        selectedEventIds[activeEvent.event_id] = true
        ranges.push({
          idx: idx,
          range: moment.range(activeEvent.lesson.start, activeEvent.lesson.end),
          timeLabel: activeEvent.lessonLTTime
        })
      })
      return {selectedEventIds, ranges}
    },
    subsForSelect () {
      return this.possibleSubs
        .filter(user => user && !user.headline && (!user.dayAbsence || user.dayAbsence.length < 1))
        .map(user => {
          const occupiedSlots = this.occupiedSlotsForUser(user)
          const occupiedLabel = this.occupiedLabelForSlots(occupiedSlots)
          const occupiedTitles = occupiedSlots
            .map(slot => slot.event && slot.event.title)
            .filter(Boolean)
            .join(', ')
          return {
            id: user.id,
            name: user.name,
            default_thumb_url: user.default_thumb_url,
            user_calendar_id: user.user_calendar_id,
            user_tags: user.user_tags,
            occupiedLabel: occupiedLabel,
            occupiedTitles: occupiedTitles,
            occupied: occupiedSlots.length > 0
              ? {
                events: [{
                  event_id: -1,
                  event_type: 'lesson',
                  title: occupiedLabel
                }]
              }
              : false
          }
        })
    }
  },
  methods: {
    occupiedSlotsForUser (user) {
      const {selectedEventIds, ranges} = this.selectedLessonRanges
      if (ranges.length < 1) {
        return []
      }
      const dayEvents = user.dayEvents || []
      const occupiedByIdx = {}
      for (let i = 0; i < dayEvents.length; i++) {
        const event = this.allEventsInAHash[dayEvents[i]]
        if (!this.eventCountsAsOccupied(event, selectedEventIds)) {
          continue
        }
        const eventRange = moment.range(event.start, event.end)
        for (let j = 0; j < ranges.length; j++) {
          const slot = ranges[j]
          if (!occupiedByIdx[slot.idx] && slot.range.overlaps(eventRange)) {
            occupiedByIdx[slot.idx] = {
              idx: slot.idx,
              timeLabel: slot.timeLabel,
              event: event
            }
          }
        }
      }
      return ranges
        .map(slot => occupiedByIdx[slot.idx])
        .filter(Boolean)
    },
    eventCountsAsOccupied (event, selectedEventIds) {
      if (!event || event.canceled) {
        return false
      }
      if (selectedEventIds[event.id]) {
        return false
      }
      return !NON_OCCUPYING_TYPES[event.event_type]
    },
    occupiedLabelForSlots (occupiedSlots) {
      const total = this.selectedLessonRanges.ranges.length
      if (occupiedSlots.length < 1 || total < 1) {
        return ''
      }
      const times = occupiedSlots
        .map(slot => slot.timeLabel)
        .filter(Boolean)
        .join(', ')
      if (total === 1) {
        const occupied = this.$t('vue2.sub_scheduler.occupied')
        return times ? occupied + ' ' + times : occupied
      }
      const countLabel = this.$t('vue2.sub_scheduler.occupied_in_selected', {
        occupied: occupiedSlots.length,
        total: total
      }).replace('{occupied}', occupiedSlots.length).replace('{total}', total)
      return times ? countLabel + ' · ' + times : countLabel
    },
    onAdd (user) {
      this.$emit('add', user)
    }
  }
}
</script>

<style scoped>
.active-events-sub__meta {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.active-events-sub__busy {
  display: flex;
  align-items: flex-start;
  font-size: 10px;
  line-height: 14px;
  margin-top: 1px;
  word-break: break-word;
}

.active-events-sub__busy .icon-warning {
  margin-right: 4px;
}

img {
  height: 18px;
  margin-right: 10px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// DSelectSubsActiveEvents.vue?46445b89